var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("error",c,p,1),c,p,0,12,65,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<p class=\"field-hint-light_error\">");t.b(t.t(t.f("error",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# error }}\n<p class=\"field-hint-light_error\">{{{ error }}}</p>\n{{/ error }}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/js/lib/component/input/login/hint_content.html
// module id = 165
// module chunks = 4